<template>
  <div>
    <div v-show="showBar">
      <div class="unauthorized-feature-wrapper">
        <div class="unauthorized-feature-bar">
          <diamond-icon class="icon" title="Alerta"></diamond-icon>
          Seu plano não comporta essa funcionalidade. Você pode alterar seu
          plano a qualquer hora!
          <a href="/v2.html#/payment">Clique aqui para atualizar seu plano</a>
        </div>
      </div>

      <div v-show="showOverlay" class="unauthorized-feature-overlay">
        <div class="content">
          Assine o
          <a href="/v2.html#/payment" id="plan-name">Plano {{ planName }}</a>
          para ter acesso a esta solução!
        </div>
      </div>
    </div>
    <div v-show="showResource">
      <div class="unauthorized-resource">
        Este recurso é exclusivo para o {{ planName }}, no ClippFácil não estará
        disponível
      </div>
    </div>
  </div>
</template>

<script>
import DiamondIcon from 'vue-material-design-icons/DiamondStone';
import { SYSTEM_VARIABLE } from '@/modules/Application';

export default {
  components: {
    DiamondIcon,
  },
  props: ['menus'],
  name: 'UnauthorizedFeature',
  async mounted() {
    this.mapMenus();
    await this.checkIsUnauthorized();
  },
  data() {
    return {
      normalizedMenu: [],
      showBar: false,
      showOverlay: false,
      showResource: false,
      planName: 'ClippFácil',
      plans: {
        CLIPPFACIL: {
          name: 'ClippFácil',
        },
        CLIPP360: {
          name: 'Clipp360',
        },
      },
      LANDINGPAGE_URL: SYSTEM_VARIABLE.LANDINGPAGE_URL,
    };
  },
  methods: {
    async checkIsUnauthorized() {
      this.showResource = false;
      this.showBar = false;
      this.showOverlay = false;
      const resource360 = window.localStorage.getItem('resource360');
      const disallowedPackages = JSON.parse(
        window.localStorage.getItem('disallowedPackages'),
      );
      const exclusivePackages = JSON.parse(
        window.localStorage.getItem('exclusivePackages'),
      );

      const matchingMenu = this.normalizedMenu[this.$route.name];

      if (!matchingMenu) return;

      await this.checkPlanName(matchingMenu.identifier);

      if (disallowedPackages.includes(matchingMenu.identifier)) {
        this.showBar = true;
        this.showOverlay = true;
      }
      if (resource360 && exclusivePackages.includes(matchingMenu.identifier)) {
        this.showBar = false;
        this.showOverlay = false;
        this.showResource = true;
      }
    },
    mapMenus() {
      this.menus.forEach((value) => {
        if (value.children && value.children.length > 0) {
          this.normalizeMenu(value.children, value);
        }
      });
    },
    normalizeMenu(children, masterMenu) {
      children.forEach((child) => {
        if (child.children && child.children.length) {
          return this.normalizeMenu(child.children, masterMenu);
        }
        if (child.frontendv2) {
          this.normalizedMenu[child.frontendv2.name] = child;
        }
        return child;
      });
    },
    async checkPlanName() {
      const domain = this.LANDINGPAGE_URL;

      if (domain.indexOf('clipp360')) {
        this.planName = this.plans.CLIPP360.name;
      }
    },
  },
};
</script>
